import React from 'react';
import {Combobox, Transition, Popover} from '@headlessui/react';
import clsx from 'clsx';
import ClientPortal from '~/components/global/ClientPortal';

//components
import Sorting from './CollectionSorting';
import NativeCollectionFilter from './CollectionFilter/NativeCollectionFilter';

export default function CollectionMobileFilterAndSort({
  hideFacets,
  sortVariant,
}: {
  hideFacets?: string[];
  sortVariant?: 'search';
}) {
  return (
    <div className="-mx-5 mb-10 flex items-center justify-between bg-hk-orange px-5 py-2">
      <Popover className="mr-2 md:hidden">
        {({open}) => (
          <>
            <Popover.Button className="outline-none">
              <div className="flex items-center space-x-2 rounded-sm bg-white px-4 py-1">
                <span className="text-xs">Filter</span>
                <div className="">
                  <svg
                    className="w-[16px] md:w-[26px]"
                    viewBox="0 0 26 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M20.3333 2.75C20.3333 4.22276 21.5272 5.41667 23 5.41667C24.4728 5.41667 25.6667 4.22276 25.6667 2.75C25.6667 1.27724 24.4728 0.0833333 23 0.0833333C21.5272 0.0833333 20.3333 1.27724 20.3333 2.75ZM3 3.25H23V2.25H3V3.25Z"
                      fill="black"
                    />
                    <path
                      d="M5.66667 10.75C5.66667 12.2228 4.47276 13.4167 3 13.4167C1.52724 13.4167 0.333334 12.2228 0.333334 10.75C0.333334 9.27724 1.52724 8.08333 3 8.08333C4.47276 8.08333 5.66667 9.27724 5.66667 10.75ZM23 11.25H3V10.25H23V11.25Z"
                      fill="black"
                    />
                    <path
                      d="M20.3333 18.75C20.3333 20.2228 21.5272 21.4167 23 21.4167C24.4728 21.4167 25.6667 20.2228 25.6667 18.75C25.6667 17.2772 24.4728 16.0833 23 16.0833C21.5272 16.0833 20.3333 17.2772 20.3333 18.75ZM3 19.25H23V18.25H3V19.25Z"
                      fill="black"
                    />
                  </svg>
                </div>
              </div>
            </Popover.Button>

            <ClientPortal>
              <Popover.Panel className="fixed left-0 top-0 z-[100] h-screen w-full text-black">
                <div className="absolute left-0 top-0 h-full w-full bg-black bg-opacity-20"></div>
                <div className="z-1 absolute top-0 left-0 h-full w-10/12 bg-white shadow-md">
                  <Popover.Button className="mb-10 mt-4 pl-5 outline-none">
                    <svg
                      width="15"
                      height="15"
                      viewBox="0 0 15 15"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M7.5 9.35849L1.85849 15L0 13.1415L5.64151 7.5L0 1.85849L1.85849 0L7.5 5.64151L13.1415 0L15 1.85849L9.35849 7.5L15 13.1415L13.1415 15L7.5 9.35849Z"
                        fill="black"
                      />
                    </svg>
                  </Popover.Button>
                  <NativeCollectionFilter hideFacets={hideFacets} />
                </div>
              </Popover.Panel>
            </ClientPortal>
          </>
        )}
      </Popover>

      <Sorting variant={sortVariant} />
    </div>
  );
}
